import { createFileRoute } from '@tanstack/react-router';

import { NIS2EvidencePage } from '@/features/nis2/components/NIS2EvidencePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/evidence')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2Evidence'),
  }),
  component: NIS2EvidencePage,
});
